import { Edit } from "react-admin";

const EditFormContainer = Edit;

export default EditFormContainer;

export interface EditFormContainerProps {}
